import React from 'react';
import useInputController, { isEmpty, createInputValidator } from '../hooks/useInputController';

import type { TextareaHTMLAttributes } from 'react';

type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'onChange'> & {
	value: string;
	onChange?: (value: string) => void;
	debounce?: number;
};

const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(
	({ value, onChange, debounce, onBlur: externalOnBlur, ...inputProps }, ref) => {
		const controlled = useInputController(value, onChange, {
			name: inputProps.name,
			debounce,
			format: v => (isEmpty(v) ? '' : String(v)),
			parse: v => v,
			validate: createInputValidator(inputProps)
		});

		function onBlur(event: React.FocusEvent<HTMLTextAreaElement>) {
			controlled.onBlur();
			externalOnBlur?.(event);
		}

		return (
			<textarea
				{...inputProps}
				value={controlled.value}
				onChange={controlled.onChange}
				onBlur={onBlur}
				ref={ref}
			/>
		);
	}
);

export default TextArea;
